export default "__VITE_ASSET__f847e898__"